import React from 'react'
import ReactDOM from 'react-dom'
import Flow from './flow'

import { Provider } from 'react-redux'
import store from './store'

import './static/css/flow.css'
ReactDOM.render(
  <Provider store={store}>
    <Flow />
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js